(() => {
  if (!customElements.get('hexcaps-my-bike')) {
    customElements.define('hexcaps-my-bike', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.result = this.querySelector('[data-bike-result]');
        this.opener = this.querySelector('[data-bike-open]');
        this.key = this.dataset.storageKey;
        this.profile = this.read();
        this.opener.hidden = false;
        this.opener.addEventListener('click', () => {
          this.profile = this.read() || this.profile;
          this.profile ? this.showResult() : this.showForm();
          this.dialog.showModal();
        });
        this.querySelector('[data-bike-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => this.opener.focus());
        this.dialog.addEventListener('click', (event) => {
          const rect = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
        });
        this.form.elements.bolt.addEventListener('change', () => this.updateBolt());
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (!this.form.reportValidity()) return;
          const values = Object.fromEntries(new FormData(this.form));
          this.profile = { version: 1, stem: values.stem, topcap: values.topcap, bolt: values.bolt, boltNote: values.bolt === 'known' ? values.boltNote.trim().slice(0, 100) : '' };
          this.persisted = false;
          try { localStorage.setItem(this.key, JSON.stringify(this.profile)); this.persisted = true; } catch (_) { /* Keep the setup usable when browser storage is blocked. */ }
          this.showResult();
          this.result.querySelector('a').focus();
        });
        this.querySelector('[data-bike-edit]').addEventListener('click', () => { this.showForm(); this.form.elements.stem.focus(); });
        this.querySelector('[data-bike-reset]').addEventListener('click', () => {
          try { localStorage.removeItem(this.key); } catch (_) { /* Storage may be unavailable. */ }
          this.profile = null;
          this.form.reset();
          this.showForm();
          this.form.elements.stem.focus();
        });
      }
      read() {
        try {
          const value = JSON.parse(localStorage.getItem(this.key));
          if (value && value.version === 1 && ['separate', 'integrated', 'unknown'].includes(value.stem) && ['round', 'other', 'unknown'].includes(value.topcap) && ['known', 'unknown'].includes(value.bolt)) {
            this.persisted = true;
            return { ...value, boltNote: String(value.boltNote || '').slice(0, 100) };
          }
        } catch (_) { /* Ignore invalid or unavailable saved data. */ }
        return null;
      }
      updateBolt() {
        const known = this.form.elements.bolt.value === 'known';
        this.querySelector('[data-bolt-details]').hidden = !known;
        this.form.elements.boltNote.required = known;
      }
      showForm() {
        this.form.hidden = false;
        this.result.hidden = true;
        if (this.profile) Object.entries(this.profile).forEach(([key, value]) => { if (this.form.elements[key]) this.form.elements[key].value = value; });
        this.updateBolt();
      }
      showResult() {
        this.showForm();
        const labels = ['stem', 'topcap', 'bolt'].map((key) => this.form.elements[key].selectedOptions[0].textContent);
        this.querySelector('[data-bike-details]').textContent = labels.join(' / ') + (this.profile.boltNote ? ' / ' + this.profile.boltNote : '');
        this.querySelector('[data-bike-storage-note]').textContent = this.persisted ? 'Saved on this browser only.' : 'Browser storage is unavailable. Your setup is saved for this visit only.';
        this.form.hidden = true;
        this.result.hidden = false;
      }
    });
  }
  if (!customElements.get('hexcaps-showcase')) {
    customElements.define('hexcaps-showcase', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.track = this.querySelector('.hx-showcase__track');
        this.slides = [...this.querySelectorAll('.hx-showcase__slide')];
        this.previous = this.querySelector('[data-showcase-prev]');
        this.next = this.querySelector('[data-showcase-next]');
        this.status = this.querySelector('[data-showcase-status]');
        this.slides.forEach((slide, index) => slide.setAttribute('aria-label', `Slide ${index + 1} of ${this.slides.length}`));
        this.querySelector('.hx-showcase__controls').hidden = this.slides.length < 2;
        const move = (delta) => {
          const target = this.slides[Math.max(0, Math.min(this.slides.length - 1, this.currentIndex() + delta))];
          if (target) this.track.scrollTo({ left: this.track.scrollLeft + target.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.previous.addEventListener('click', () => move(-1));
        this.next.addEventListener('click', () => move(1));
        this.track.addEventListener('scroll', () => this.updateControls(), { passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
        });
        this.addEventListener('shopify:block:select', (event) => {
          const slide = event.target.closest('.hx-showcase__slide');
          if (!slide || !this.slides.includes(slide)) return;
          this.track.scrollTo({ left: this.track.scrollLeft + slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: 'instant' });
          this.updateControls();
        });
        this.updateControls();
      }
      currentIndex() {
        const left = this.track.getBoundingClientRect().left;
        return this.slides.reduce((best, slide, index) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(this.slides[best].getBoundingClientRect().left - left) ? index : best, 0);
      }
      updateControls() {
        const index = this.currentIndex();
        this.previous.disabled = index === 0;
        this.next.disabled = index >= this.slides.length - 1;
        const label = this.slides.length ? `Slide ${index + 1} of ${this.slides.length}` : '';
        if (this.status && this.status.textContent !== label) this.status.textContent = label;
      }
    });
  }
})();
